
    var dd_lazyLoaderObject;

var dd_lazyLoader = function(){
  
  this.marginAllowed = 2000;
  this.quality = 'low';
  
  this.lazyElt={};
  this.allLoaded = false;
  
}

dd_lazyLoader.prototype.init = function(){
  var thisObject = this;
  
  this.decideQuality();
  
  //Parsing all dd_lazyLdElt
  jQuery('.dd_lazyLdElt').each(function(){
    thisObject.initialTreatElt(jQuery(this));
  });
  
  jQuery(document).scroll(function(){
    if(!thisObject.allLoaded){
      thisObject.checkCurrentOffsetOfElts();
      thisObject.checkLoadingOfElts(jQuery(window).scrollTop());
    }
  });
  thisObject.checkLoadingOfElts(jQuery(window).scrollTop());
};

dd_lazyLoader.prototype.decideQuality = function(){
  //var width = window.screen.width * window.devicePixelRatio;
  var width =jQuery(window).width();
  //var height = window.screen.height * window.devicePixelRatio;
  var height =jQuery(window).height(); 
  //width > 770px
  
  if(width > 770){
    this.quality = 'high';
  }
  
};

dd_lazyLoader.prototype.initialTreatElt = function(jQueryDOM){
  var randomID = String(Math.floor(Math.random() * 9999999999999));
  var eltScrollTop = jQueryDOM.offset().top;
  
  this.lazyElt[randomID]={
    scrollTop:eltScrollTop,
    loaded:false
  };
  
  jQueryDOM.attr('data-ddlazyeltid',randomID);
};

dd_lazyLoader.prototype.checkCurrentOffsetOfElts = function(){
  var thisObject = this;
  for (var key in thisObject.lazyElt) {
    // skip loop if the property is from prototype
    if (!thisObject.lazyElt.hasOwnProperty(key)) continue;
    
    var obj = thisObject.lazyElt[key];
    if(obj.loaded){
      continue;
    }
    var newoffSet = jQuery('.dd_lazyLdElt[data-ddlazyeltid='+key+']').offset().top;
    thisObject.lazyElt[key].scrollTop = newoffSet;
  }
};

dd_lazyLoader.prototype.checkLoadingOfElts = function(scrollLevel){
  var thisObject = this;
  for (var key in thisObject.lazyElt) {
      // skip loop if the property is from prototype
      if (!thisObject.lazyElt.hasOwnProperty(key)) continue;

      
      var obj = thisObject.lazyElt[key];
    
    
      if(Math.abs(obj.scrollTop - scrollLevel) < thisObject.marginAllowed){
		thisObject.loadElt(key);
      }
  }
};

dd_lazyLoader.prototype.loadElt = function(id){
  var thisObject = this;
  var obj = this.lazyElt[id];
  if(obj.loaded){
    return false;
  }
  
  var jQueryElt = jQuery('.dd_lazyLdElt[data-ddlazyeltid='+id+']');
  
  if(jQueryElt.prop('nodeName') === "IMG"){
    var imgUrl = jQueryElt.attr('data-ddlazyloadurl');
    var imgUrl_HD = jQueryElt.attr('data-ddlazyloadurl_hd');
    if(imgUrl){
      if(thisObject.quality==='high' && imgUrl_HD){
        jQueryElt.attr('src',imgUrl_HD);
      }else{
        jQueryElt.attr('src',imgUrl);
      }
      
    }
  }else if(jQueryElt.prop('nodeName') === "SOURCE" && jQueryElt.attr("type")==="video/mp4"){
    var vidSrc = jQueryElt.attr('data-ddlazyloadurl');
    var vidSrc_HD = jQueryElt.attr('data-ddlazyloadurl_hd');
    if(vidSrc){
      
      if(thisObject.quality==='high' && vidSrc_HD){
        jQueryElt.attr('src',vidSrc_HD);
      }else{
        jQueryElt.attr('src',vidSrc);
      }
      
      //Trick to reload video sources and play it
      var parentDOM = jQueryElt.parents('video').parent().html();
      jQueryElt.parents('video').parent().html(parentDOM);
    }
  }
  
  
  this.lazyElt[id].loaded = true;
  this.checkIfAllLoaded();
};


dd_lazyLoader.prototype.checkIfAllLoaded = function(){
  var thisObject = this;
  for (var key in thisObject.lazyElt) {
      // skip loop if the property is from prototype
      if (!thisObject.lazyElt.hasOwnProperty(key)) continue;
	
      var obj = thisObject.lazyElt[key];
      if(!obj.loaded){return false;}
      
  }
  this.allLoaded = true;
  return true;
};


//Declare the dd_lazyLoader
dd_lazyLoaderObject = new dd_lazyLoader();

jQuery(document).ready(function(){
    //Initiate the events (buttons ...)
    dd_lazyLoaderObject.init();
});
